const formatDate = (dateString) => {
    const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0'); // Ensure two-digit day
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    
    return `${day}/${month}/${year}`;
}

export default formatDate;